var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"population-view"},[_c('PopulationList',{attrs:{"patient-list":_vm.patientList,"list-title":_vm.listTitle,"url":_vm.url}}),_c('div',{staticClass:"detail"},[_c('router-view',{attrs:{"url":_vm.url,"print":null}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }